var content = require("!!../../../../../_postcss-loader@3.0.0@postcss-loader/src/index.js??ref--5-1!./colorgrid.css");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {"injectType":"singletonStyleTag"}

options.insert = "head";
options.singleton = true;

var update = require("!../../../../../_style-loader@1.0.0@style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
